module.exports = __webpack_public_path__ + "img/pp_service3.047bcbcb.png";